import { IOption, isValidDate } from 'shared-components';
import { TravelStatusEnum } from 'api-paths-cas';

import { IDate } from '../../../../types';

const arrayOfArrivalStatuses: TravelStatusEnum[] = [
  TravelStatusEnum.None,
  TravelStatusEnum.NoBookingYet,
  TravelStatusEnum.Booked,
  TravelStatusEnum.Arrived,
  TravelStatusEnum.Withdraw,
  TravelStatusEnum.Defer,
  TravelStatusEnum.TravelPrevented,
  TravelStatusEnum.TravelCancelled,
];

export const DropdownOptions: IOption[] = arrayOfArrivalStatuses.map(status => ({
  label: status,
  value: status,
}));

export const RequestNewTravelTicketDropdownOptions: IOption[] = [
  {
    label: 'Yes',
    value: 'Yes',
  },
  {
    label: 'No',
    value: 'No',
  },
];

export const validateDate = (dateValue: IDate): string => {
  const { YYYY, DD, MM } = dateValue;
  if (YYYY && DD && MM) {
    const isValid = isValidDate(dateValue);
    if (!isValid) {
      return "Doesn't look like a valid date";
    }
  }
  return '';
};
